export default __webpack_public_path__ + "static/media/home-travel-agency-packages-img03.3dada7d7.jpg";